// eslint-disable-next-line jira/restricted/react
import React, { type ComponentType, PureComponent } from 'react';
import ErrorIcon from '@atlaskit/icon/glyph/error';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import type { IntlShapeV2 as IntlShape } from '@atlassian/jira-intl/src/v2/types.tsx';
import commonMessages from '@atlassian/jira-servicedesk-common/src/i18n';
import { InlineErrorText, ErrorMessageContainer } from './styled';

export type Props = {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	StatefulUserPickerComponent: ComponentType<any>;
	saveError: string | null;
	onSelect: (arg1: string) => void;
	intl: IntlShape;
};

// eslint-disable-next-line jira/react/no-class-components
class DialogContent extends PureComponent<Props> {
	renderSaveError() {
		const {
			intl: { formatMessage },
			saveError,
		} = this.props;
		return saveError ? (
			<ErrorMessageContainer>
				<ErrorIcon
					primaryColor={token('color.icon.danger', colors.R300)}
					label={formatMessage(commonMessages.error)}
				/>
				<InlineErrorText>{saveError}</InlineErrorText>
			</ErrorMessageContainer>
		) : null;
	}

	render() {
		const { StatefulUserPickerComponent, onSelect } = this.props;
		return (
			<div>
				<StatefulUserPickerComponent onSelect={onSelect} />
				{this.renderSaveError()}
			</div>
		);
	}
}

export default injectIntl(DialogContent);
